<div class="col-lg-6 question-label">
    <label>{{question.questionLabel}}
        <span *ngIf="question?.required">*</span>
    </label>
</div>

<div class="col-lg-6">
    <p-radioButton
        [id]="question.key + 'Yes'"
        class="padding-right inline-block" 
        [value]="radiovalue1"
        #radiobuttonModel="ngModel"
        [class.invalid]="showError"
        [name]="name ? name + 'radio' :question?.name"
        [(ngModel)]="question.answer"
        [disabled]="disabled"
        [required]="question?.required"
        (onClick)="ChangeAns('Yes',$event)">
    </p-radioButton>
    <label for="{{question.key}}Yes">{{radioButtonLabel1}}</label>
    <p-radioButton
        [id]="question.key + 'No'"
        class="padding-left padding-right inline-block"
        [value]="radiovalue2"
        #radiobuttonModel="ngModel"
        [class.invalid]="showError"
        [name]="name ? name + 'radio' :question?.name"
        [(ngModel)]="question.answer"
        [disabled]="disabled"
        [required]="question?.required"
        (onClick)="ChangeAns('No',$event)">
    </p-radioButton>
    <label for="{{question.key}}No">{{radioButtonLabel2}}</label>
</div>
